import classnames from 'classnames';
import React, { Component } from 'react';
import { translateStatus } from '../../../utils';
import './NavListAccordion.css';

class NavListAccordion extends Component {

  componentDidMount() {
    this.showNavAccordion();
    this.showNavAccordionOnEnter();
  }

  showNavAccordion() {
    var navList = document.getElementsByClassName("navAccDetails");
    var downIconNavAcc = document.getElementsByClassName("downIconNavAcc");
    for (var i = 0; i < navList.length; i++) {
      navList[i].onclick = (function () {
        /* Toggle between hiding and showing the active panel */
        var panel = this.nextElementSibling;
        if (panel.className === "gdocs-display-block") {
          for (var v = 0; v < navList.length; v++) {
            navList[v].nextElementSibling.className = "gdocs-display-none";
            navList[v].childNodes[0].setAttribute("aria-expanded", "false");
            downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          }
          panel.className = "gdocs-display-none";
          this.childNodes[0].setAttribute("aria-expanded", "false")
          if (this.childNodes[0].children[1].children[3] !== undefined) {
            this.childNodes[0].children[1].children[3].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          } else {
            this.childNodes[0].children[1].children[2].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          }
        } else {
          for (var v = 0; v < navList.length; v++) {
            navList[v].nextElementSibling.className = "gdocs-display-none";
            navList[v].childNodes[0].setAttribute("aria-expanded", "false");
            downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
          }
          panel.className = "gdocs-display-block";
          this.childNodes[0].setAttribute("aria-expanded", "true")
          if (this.childNodes[0].children[1].children[3] !== undefined) {
            this.childNodes[0].children[1].children[3].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
          } else {
            this.childNodes[0].children[1].children[2].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
          }
        }
      });
    }
  }

  showNavAccordionOnEnter() {
    var navList = document.getElementsByClassName("navAccDetails");
    var downIconNavAcc = document.getElementsByClassName("downIconNavAcc");
    for (var i = 0; i < navList.length; i++) {
      navList[i].onkeyup = (function (e) {
        /* Toggle between hiding and showing the active panel */
        if (e.keyCode === 13 || e.keyCode === 32) {
          var panel = this.nextElementSibling;
          if (panel.className === "gdocs-display-block") {
            for (var v = 0; v < navList.length; v++) {
              navList[v].nextElementSibling.className = "gdocs-display-none";
              navList[v].childNodes[0].setAttribute("aria-expanded", "false");
              downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
            }
            panel.className = "gdocs-display-none";
            this.childNodes[0].setAttribute("aria-expanded", "false");
            if (this.childNodes[0].children[1].children[3] !== undefined) {
              this.childNodes[0].children[1].children[3].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
              this.childNodes[0].children[1].children[3].setAttribute("aria-expanded", "false")
            } else {
              this.childNodes[0].children[1].children[2].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
              this.childNodes[0].children[1].children[2].setAttribute("aria-expanded", "false")
            }
          } else {
            for (var v = 0; v < navList.length; v++) {
              navList[v].nextElementSibling.className = "gdocs-display-none";
              navList[v].childNodes[0].setAttribute("aria-expanded", "false");
              downIconNavAcc[v].className = "icon icon-chevron-down downIconNavAcc gdocs-float-left";
            }
            panel.className = "gdocs-display-block";
            this.childNodes[0].setAttribute("aria-expanded", "true")
            if (this.childNodes[0].children[1].children[3] !== undefined) {
              this.childNodes[0].children[1].children[3].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
            } else {
              this.childNodes[0].children[1].children[2].className = "icon icon-chevron-up downIconNavAcc gdocs-float-left";
            }
          }
        }
      });
    }
  }

  render() {
    return (
      <div className={classnames({
        'noDisplay': this.props.hideAccordian,
        'navAccContainer': true
      })}>
        <div className="navAccDetails" id='navAccDetails_main'>
          <div role="button" aria-expanded="false" tabindex="0" onClick={this.props._onClick}>
            <div className="gdocs-float-left">
              <h4 className='NavListAccordionHead gdocs-responsive-text'>{this.props.navAccHeading}</h4>
            </div>
            <div className="gdocs-float-right">
              {
                this.props.status !== 'optional' ? (
                  <div className="statusNavcAcc gdocs-float-left">{translateStatus(this.props.lang, this.props.status)}</div>
                ) : ''
              }
              {
                this.props.status !== 'optional' ? (
                  <div className={this.props.status === 'complete'
                    ? 'icon icon-circle-confirmation-solid iconNavAccStatus'
                    : 'icon icon-circle-error-solid case-in-complete-icon'}
                    aria-hidden='true'
                  >
                  </div>
                ) : ''
              }
              {
                this.props.status === 'optional' ? (
                  <div className="statusNavcAcc gdocs-float-left">
                    <span className="optional-status">{translateStatus(this.props.lang, this.props.status)}</span>
                  </div>
                ) : ''
              }
              <div className="separatorNavAcc gdocs-float-left"></div>
              <div className="icon icon-chevron-down downIconNavAcc gdocs-float-left" aria-hidden='true' dir="dir"></div>
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
        </div>
        <div className="gdocs-display-none">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default NavListAccordion;

NavListAccordion.defaultProps = {
  hideAccordian: false
}

export class NavListAccordionWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.navList = document.getElementsByClassName("navAccDetails");
  }

  componentDidMount() {
    if ((this.props.open == 0 || this.props.open) && this.navList.length > 0) {
      if (this.navList[this.props.open]) {
        this.navList[this.props.open].nextElementSibling.className = "gdocs-display-block";
      }
    }
  }

  render() {
    // if(this.navList.length > 0){
    //   if(this.props.open){
    //     this.navList[this.props.open].nextElementSibling.className = "gdocs-display-block";
    //   }
    // }

    return (
      <div className="nav-list-accordion-wrapper">
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NavListAccordion/NavListAccordion.js